import {Add, Cached} from "@mui/icons-material";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Switch,
  TextField,
  Typography,
  Alert,
  AlertTitle, Tooltip,
} from "@mui/material";
import Stack from "@mui/system/Stack";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/en-gb";
import { ModalAcceptButton } from "../../../../constants/component.constants";
import { ResponsiveRow } from "../../../../constants/layout.constants";
import ModalContainerModule from "../../../modules/modalContainer";
import LeaseChargeItems from "../../../modules/populateLeaseChargeItems";
import { useEffect, useState } from "react";
import {
  adjustForTimezone,
  isEmptyString,
  isNullUndefined,
  tryParseInt,
  tryParseFloat,
  isValidDate,
  isArray,
  isEmptyArray,
  getDayStart,
} from "../../../../util/util";
import dayjs from "dayjs";
import {
  issueWarnMessage,
  issueResponseMessage,
} from "../../../../actions/message";
import {
  saveLeaseData,
  getLeaseTerms,
  getLeaseTypes,
  leaseUnitCharges,
  updateActivateLease,
} from "../../../../services/lease.service.js";
import {
  getFacilityOptions,
  getRentDays,
  getNotificationDays,
  getRentPeriods,
  getUnitOptions,
  allUnitOptions,
} from "../../../../services/list.service.js";
import MUIAutoCompleteMultiSelectForm from "../../../inputs/MUIAutoCompleteMultiSelectForm";
import AddNewUser from "../../addNewUser.js";
import PersonOrgSearch from "../../personOrgSearch.js";
import AddNewOrganization from "../../addNewOrganization.js";
import LatePenaltyConfig, {
  normalizeLatePenalty,
  validateLatePenalty,
} from "../../../modules/latePenaltyConfig";

/**
 *
 * REQUIRED PROPS
 *
 *
 * setTenantModal
 * setIsTenantSelect
 *
 * billingPeriods
 * chargeItemsTotal
 * leaseChargesTableRows
 * facilityOptions
 * leaseTermOptions
 * saveLease
 * selectedLease
 * task
 * updateLease
 *
 */
export default function AddLeaseModal(props) {
  //
  const [rentDays, setRentDays] = useState([]);
  const [notificationDays, setNotificationDays] = useState([]);
  const [billingPeriods, setBillingPeriods] = useState([]);
  const [facilityOptions, setFacilityOptions] = useState([]);
  const [leaseTermOptions, setLeaseTermOptions] = useState([]);
  const [leaseTypeOptions, setLeaseTypeOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [leaseTerm, setLeaseTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [expirationDate, setExpirationDate] = useState("");
  const [leaseTypeCd, setLeaseTypeCd] = useState("");
  const [rentPeriodCode, setRentPeriodCode] = useState("");
  const [rentDay, setRentDay] = useState("");
  const [notificationDay, setNotificationDay] = useState("");
  const [rentDate, setRentDate] = useState("");
  const [notificationDate, setNotificationDate] = useState("");
  const [incrementRent, setIncrementRent] = useState("");
  const [incrementDeposit, setIncrementDeposit] = useState("");
  const [hasRevenueSharing, setHasRevenueSharing] = useState(false);
  const [tenantModal, setTenantModal] = useState(false);
  const [addUserModal, setAddUserModal] = useState(false);
  const [addOrganizationModal, setAddOrganizationModal] = useState(false);
  const [incrementPeriod, setIncrementPeriod] = useState("");
  const [rentIncrementPercentage, setRentIncrementPercentage] = useState("");
  const [rentIncrementAmount, setRentIncrementAmount] = useState("");
  const [idTypeSearch, setIdTypeSearch] = useState("");
  const [idNoSearch, setIdNoSearch] = useState("");
  const [companySearch, setCompanySearch] = useState("");
  const [selectedUnitIds, setSelectedUnitIds] = useState([]);
  const [chargeUnitsOptions, setChargeUnitsOptions] = useState([]);
  const [chargeItems, setChargeItems] = useState(
    props?.selectedLease?.leaseChargeItems ?? [],
  );
  const [incrementType, setIncrementType] = useState(
    props?.selectedLease?.incrementType ?? "",
  );
  const [selectedLease, setSelectedLease] = useState(
    props?.selectedLease ?? null,
  );
  const [latePenalty, setLatePenalty] = useState(
    normalizeLatePenalty(props?.selectedLease?.latePenalty),
  );

  const MAX_INCREMENT_PERIOD = 10;

  useEffect(() => {
    if (isNullUndefined(props?.selectedLease)) {
      return;
    }
    setSelectedLease(props.selectedLease);
    setLatePenalty(normalizeLatePenalty(props.selectedLease.latePenalty));
    if (props?.task === "ActiveLeaseEdit" || props?.task === "Edit") {
      setHasRevenueSharing(props.selectedLease?.hasRevenueSharing);
      if (
        !isNullUndefined(props.selectedLease.start) &&
        !isEmptyString(props.selectedLease.start)
      ) {
        setStartDate(new Date(props.selectedLease.start));
      }
      if (
        !isNullUndefined(props.selectedLease.end) &&
        !isEmptyString(props.selectedLease.end)
      ) {
        setExpirationDate(new Date(props.selectedLease.end));
      }
      if (
        !isNullUndefined(props.selectedLease.rentDate) &&
        !isEmptyString(props.selectedLease.rentDate)
      ) {
        setRentDate(new Date(props.selectedLease.rentDate));
      }
      if (
        !isNullUndefined(props.selectedLease?.incrementPeriod) &&
        props.selectedLease?.incrementPeriod > 0
      ) {
        setIncrementType(props.selectedLease?.incrementType);
      }

      if (
        isArray(props.selectedLease.leaseChargeItems) &&
        props.selectedLease.leaseChargeItems.length > 0
      ) {
        let opt = [];
        for (let item of props.selectedLease.leaseChargeItems) {
          opt.push({
            label: item.unit.name,
            value: item.unit.id,
          });
        }
        setChargeUnitsOptions([
          ...new Map(opt.map((v) => [v.value, v])).values(),
        ]);
      }

      setLeaseTerm(props.selectedLease.leaseTerms);
      setLeaseTypeCd(props.selectedLease.leaseTypeCd);
      setRentPeriodCode(props.selectedLease.billingPeriod);
      setRentDay(props.selectedLease.rentDay);
      setIncrementDeposit(props.selectedLease.incrementDeposit);
    }

    if (props.selectedLease.hasRevenueSharing) {
      if (
        !isNullUndefined(props.selectedLease.notificationDate) &&
        !isEmptyString(props.selectedLease.notificationDate)
      ) {
        setNotificationDate(new Date(props.selectedLease.notificationDate));
      }
      setNotificationDay(props.selectedLease.notificationDay);
    }

    if (
      !isNullUndefined(props.selectedLease.incrementPeriod) &&
      !isEmptyString(props.selectedLease.incrementPeriod) &&
      tryParseInt(props.selectedLease.incrementPeriod, 0) > 0
    ) {
      setIncrementPeriod(props.selectedLease.incrementPeriod);
      setIncrementRent(true);
      setRentIncrementAmount(props.selectedLease.rentIncrementAmount);
      setRentIncrementPercentage(props.selectedLease.rentIncrementPercentage);
    }

    if (!isNullUndefined(props.selectedLease.facilityId)) {
      // allUnitOptions
      if (props.task === "Edit") {
        getUnitOptions(
          props.selectedLease.facilityId,
          props.selectedLease.id,
        ).then((unitOptions) => {
          // Deduplicate unitOptions by value to handle backend duplicates
          const uniqueUnitOptions = [
            ...new Map(unitOptions.map((v) => [v.value, v])).values(),
          ];
          const selected = uniqueUnitOptions.filter((o) =>
            props.selectedLease.unitIds.includes(o.value),
          );
          setSelectedUnitIds(selected); // TODO: GET the units linked to a lease
          setUnitOptions(uniqueUnitOptions);
        });
      } else {
        allUnitOptions(props.selectedLease.facilityId).then((unitOptions) => {
          setUnitOptions(unitOptions);
        });
      }
    }
  }, [props?.selectedLease, props?.task]);

  function onRadioChange(radio) {
    const value = radio.target.value;
    if (radio) {
      if (value === "Percentage") {
        setIncrementType(value);
      }
      if (value === "Amount") {
        setIncrementType(value);
      }
    }
  }

  function leaseTermChanged(event) {
    let value = event.target.value;
    let obj = selectedLease;
    obj.leaseTerms = value;
    if (obj.leaseTerms === "WILL") {
      obj.expirationDate = null;
    }
    setSelectedLease(obj);
    setLeaseTerm(value);
  }

  function handleStartDateChange(value) {
    let date = adjustForTimezone(new Date(value));
    let obj = selectedLease;
    obj.effectiveDate = date;
    setStartDate(date);
    setSelectedLease(obj);

    //Ensure that all lease details have the same date as Lease Start date
    let newArr = [...chargeItems];
    if (newArr.length > 0) {
      newArr.forEach((charge, i) => {
        newArr[i].effectiveDate = date;
      });
    }
    setChargeItems(newArr);
  }

  function handleExpirationDateChange(value) {
    let date = adjustForTimezone(new Date(value));
    let obj = selectedLease;
    obj.expirationDate = date;
    setExpirationDate(date);
    setSelectedLease(obj);
  }

  function leaseTypeChanged(event) {
    let value = event.target.value;
    let obj = selectedLease;
    obj.leaseTypeCd = value;
    setLeaseTypeCd(value);
    if (value !== "COM") {
      obj.hasRevenueSharing = false;
      setHasRevenueSharing(false);
    }
    setSelectedLease(obj);
  }

  function handleRentPeriodChange(event) {
    let value = event.target.value;
    let obj = selectedLease;
    obj.billingPeriod = value;
    setSelectedLease(obj);
    setRentPeriodCode(value);
  }

  function handleRentDayChange(event) {
    let value = event.target.value;
    let obj = selectedLease;
    obj.rentDay = value;
    setRentDay(value);
    setSelectedLease(obj);
  }

  function handleNotificationDayChange(event) {
    let value = event.target.value;
    let obj = selectedLease;
    obj.notificationDay = value;
    setNotificationDay(value);
    setSelectedLease(obj);
  }

  function handleNotificationDateChange(value) {
    let date = adjustForTimezone(new Date(value));
    let obj = selectedLease;
    obj.notificationDate = date;
    setNotificationDate(date);
    setSelectedLease(obj);
  }

  function handleNextRentDateChange(value) {
    let date = adjustForTimezone(new Date(value));
    let obj = selectedLease;
    obj.rentDate = date;
    setSelectedLease(obj);
    setRentDate(date);
  }

  function handleIncrementPeriodChange(event) {
    let text = event.target.value;
    let tmp = selectedLease;
    let value = tryParseInt(text, -1);
    if (value <= 0) {
      tmp.incrementPeriod = 0;
      setIncrementPeriod(0);
    } else {
      tmp.incrementPeriod = value;
      setIncrementPeriod(value);
    }
    setSelectedLease(tmp);
  }

  function handleIncrementRentSwitchToggle(event) {
    setIncrementRent(event.target.checked);
    if (!event.target.checked) {
      setIncrementDeposit(false);
      let tmp = selectedLease;
      tmp.incrementDeposit = false;
      tmp.incrementPeriod = 0;
      setIncrementPeriod(0);
      setSelectedLease(tmp);
    }
  }

  function handleIncrementDepositSwitchToggle(event) {
    setIncrementDeposit(event.target.checked);
    let tmp = selectedLease;
    tmp.incrementDeposit = event.target.checked;
    setSelectedLease(tmp);
  }

  function handleRevenueShareToggle(event) {
    let value = event.target.checked;
    let obj = selectedLease;
    obj.hasRevenueSharing = value;
    setSelectedLease(obj);
    setHasRevenueSharing(event.target.checked);
  }

  function handleIncrementChange(event) {
    let tmp = selectedLease;
    if (incrementType === "Amount") {
      tmp.rentIncrementAmount = event.target.value;
      tmp.rentIncrementPercentage = 0;
      setRentIncrementAmount(event.target.value);
      setRentIncrementPercentage(0);
    } else {
      tmp.rentIncrementAmount = 0;
      tmp.rentIncrementPercentage = event.target.value;
      setRentIncrementAmount(0);
      setRentIncrementPercentage(event.target.value);
    }
    setSelectedLease(tmp);
  }

  // function handleLeaseChargeItemAdd() {
  //   let charge = {
  //     unit: {
  //       id: "",
  //       name: "",
  //     },
  //     amount: "",
  //     chargeCode: { code: "", name: "" },
  //     taxable: false,
  //     effectiveDate:
  //       isEmptyString(startDate) || isNullUndefined(startDate)
  //         ? new Date()
  //         : startDate,
  //     note: "",
  //   };
  //   setChargeItems((chargeItems) => [...chargeItems, charge]);
  // }

  // Function to check if any Security Deposit charges exist
  function hasSecurityDepositCharges() {
    return (
      chargeItems &&
      chargeItems.some(
        (charge) => charge.chargeCode && charge.chargeCode.code === "SECDP",
      )
    );
  }

  // Function to check if any Utility Deposit charges exist
  function hasUtilityDepositCharges() {
    return (
      chargeItems &&
      chargeItems.some(
        (charge) => charge.chargeCode && charge.chargeCode.code === "UTIDP",
      )
    );
  }

  // Function to get deposit info message based on what's present
  function getDepositInfoMessage() {
    const hasSecurity = hasSecurityDepositCharges();
    const hasUtility = hasUtilityDepositCharges();

    if (hasSecurity && hasUtility) {
      return "Security Deposit and Utility Deposit invoices will be generated once the lease is activated.";
    } else if (hasSecurity) {
      return "Security Deposit invoice will be generated once the lease is activated.";
    } else if (hasUtility) {
      return "Utility Deposit invoice will be generated once the lease is activated.";
    }
    return null;
  }

  function saveLease() {
    if (validateLease()) {
      saveLeaseData(selectedLease).then((response) => {
        if (response) {
          issueResponseMessage(response);
          if (response.type !== "error") {
            props?.handleAddLeaseClose(true);
          }
        }
      });
    }
  }

  function updateLease() {
    if (validateLease()) {
      updateActivateLease(selectedLease).then((response) => {
        if (response) {
          issueResponseMessage(response);
          if (response.type !== "error") {
            props?.handleAddLeaseClose(true);
          }
        }
      });
    }
  }

  function validateLease() {
    let sendData = selectedLease;
    sendData.leaseChargeItems = chargeItems;
    sendData.latePenalty = latePenalty;
    if (
      !isNullUndefined(sendData.start) &&
      isNullUndefined(sendData.effectiveDate)
    ) {
      sendData.effectiveDate = new Date(sendData.start);
    } else if (!isNullUndefined(sendData.effectiveDate)) {
      sendData.effectiveDate = new Date(sendData.effectiveDate);
    }

    sendData.expirationDate = new Date(expirationDate);

    sendData.incrementType = incrementType; // increment type is set as first level key in state, so need to override params of the selected lease object to send

    if (sendData.leaseChargeItems.length < 1) {
      issueWarnMessage(
        "You must add at least one lease charge to save a lease.",
      );
      return;
    }

    let incrementPeriod = tryParseInt(sendData.incrementPeriod, -1);
    if (incrementPeriod > MAX_INCREMENT_PERIOD) {
      issueWarnMessage(
        "Increment period is currently limited to a maximum of " +
          MAX_INCREMENT_PERIOD +
          " years. Reduce the increment period value",
      );
      return;
    }
    // Validate
    if (isNullUndefined(sendData)) {
      issueWarnMessage("Could not determine lease");
      return false;
    }
    if (isNullUndefined(sendData.billingPeriod)) {
      issueWarnMessage("Could not determine lease rent frequency");
      return false;
    }
    if (
      isNullUndefined(sendData.facilityId) ||
      isEmptyString(sendData.facilityId)
    ) {
      issueWarnMessage("Please select a Facility.");
      return false;
    }
    if (sendData.hasRevenueSharing) {
      // add notification date
      if (
        (sendData.billingPeriod === "WEEK" ||
          sendData.billingPeriod === "MNTH") &&
        (isNullUndefined(sendData.notificationDay) ||
          isNaN(sendData.notificationDay))
      ) {
        issueWarnMessage("Could not determine lease notification day");
        return false;
      }
      sendData.notificationDay = parseInt(sendData.notificationDay);
      if (sendData.billingPeriod === "ANU") {
        let notificationDate = new Date(sendData.notificationDate);
        if (!isValidDate(notificationDate)) {
          issueWarnMessage("Could not determine lease notification date");
          return false;
        }
      }
      if (sendData.billingPeriod === "QTR" || sendData.billingPeriod === "QT") {
        let notificationDate = new Date(sendData.notificationDate);
        if (!isValidDate(notificationDate)) {
          issueWarnMessage("Could not determine lease notification date");
          return false;
        }
      }
    } else {
      sendData.hasRevenueSharing = false;
      // add rent date
      if (
        (sendData.billingPeriod === "WEEK" ||
          sendData.billingPeriod === "MNTH") &&
        (isNullUndefined(sendData.rentDay) || isNaN(sendData.rentDay))
      ) {
        issueWarnMessage("Could not determine lease rent day");
        return false;
      }
      sendData.rentDay = parseInt(sendData.rentDay);
      if (sendData.billingPeriod === "ANU") {
        let rentDate = new Date(sendData.rentDate);
        if (!isValidDate(rentDate)) {
          issueWarnMessage("Could not determine lease rent date");
          return false;
        }
      }
      if (sendData.billingPeriod === "QTR" || sendData.billingPeriod === "QT") {
        let rentDate = new Date(sendData.rentDate);
        if (!isValidDate(rentDate)) {
          issueWarnMessage("Could not determine lease rent date");
          return false;
        }
      }
    }
    let rentIncrementPercentage = !isNullUndefined(
      sendData.rentIncrementPercentage,
    )
      ? tryParseFloat(sendData.rentIncrementPercentage.toString(), -1)
      : -1;
    let rentIncrementAmount = !isNullUndefined(sendData.rentIncrementAmount)
      ? tryParseFloat(sendData.rentIncrementAmount.toString(), -1)
      : -1;
    if (incrementPeriod > 0) {
      // when 0 means rent increment not being used
      if (
        isNullUndefined(sendData.incrementType) ||
        isEmptyString(sendData.incrementType)
      ) {
        issueWarnMessage("No increment type selected");
        return false;
      }
      if (
        sendData.incrementType === "Percentage" &&
        (isNullUndefined(sendData.rentIncrementPercentage) ||
          isNaN(sendData.rentIncrementPercentage))
      ) {
        issueWarnMessage(
          "Rent percentage increment is required when incrementing rent by a percentage",
        );
        return false;
      }

      if (
        (rentIncrementPercentage <= 0 || rentIncrementPercentage > 100) &&
        sendData.incrementType === "Percentage"
      ) {
        issueWarnMessage(
          "Increment percentage can only be greater than 0% and not more than 100%",
        );
        return false;
      }
      if (
        sendData.incrementType === "Amount" &&
        (isNullUndefined(sendData.rentIncrementAmount) ||
          isNaN(sendData.rentIncrementAmount))
      ) {
        issueWarnMessage(
          "Increment rent amount is required when incrementing rent by an amount",
        );
        return false;
      }
      if (rentIncrementAmount <= 0 && sendData.incrementType === "Amount") {
        issueWarnMessage("Increment amount should be greater than 0");
        return false;
      }
    }

    sendData.rentIncrementPercentage = tryParseInt(rentIncrementPercentage, 0);
    sendData.rentIncrementAmount = tryParseInt(rentIncrementAmount, 0);

    let leaseEffective = sendData.start
      ? new Date(sendData.start)
      : new Date(sendData.effectiveDate);

    if (!isValidDate(leaseEffective)) {
      issueWarnMessage("Cannot proceed validating the lease start date.");
      return false;
    }

    if (
      isNullUndefined(sendData.leaseTerms) ||
      isEmptyString(sendData.leaseTerms) ||
      sendData.leaseTerms === null
    ) {
      issueWarnMessage("Please provide a Lease Term.");
      return false;
    }

    if (
      sendData?.leaseTerms === "FXD" &&
      (isNullUndefined(sendData.expirationDate) ||
        !isValidDate(sendData.expirationDate))
    ) {
      issueWarnMessage("A lease expiration date is required.");
      return false;
    }
    if (
      !isNullUndefined(sendData.expirationDate) &&
      isValidDate(sendData.expirationDate)
    ) {
      if (sendData.expirationDate <= getDayStart(new Date())) {
        issueWarnMessage("Lease expiration date cannot be before today");
        return false;
      }
      if (sendData.expirationDate <= sendData.effectiveDate) {
        issueWarnMessage(
          "Lease expiration date cannot be before lease start date",
        );
        return false;
      }
      sendData.expirationDate = adjustForTimezone(sendData.expirationDate);
    }

    if (isArray(sendData.leaseChargeItems)) {
      for (let i = 0; i < sendData.leaseChargeItems.length; i++) {
        let charge = sendData.leaseChargeItems[i];
        const itemIndex = i + 1;

        // Validate Unit
        if (
          isNullUndefined(charge.unit) ||
          isNullUndefined(charge.unit.id) ||
          isEmptyString(charge.unit.id)
        ) {
          issueWarnMessage(
            `Unit is required for lease charge item ${itemIndex}.`,
          );
          return false;
        }

        // Validate Charge Type
        if (
          isNullUndefined(charge.chargeCode) ||
          isNullUndefined(charge.chargeCode.code) ||
          isEmptyString(charge.chargeCode.code)
        ) {
          issueWarnMessage(
            `Charge Type is required for lease charge item ${itemIndex}.`,
          );
          return false;
        }

        // Validate Amount
        if (
          isNullUndefined(charge.amount) ||
          isEmptyString(charge.amount.toString())
        ) {
          issueWarnMessage(
            `Amount is required for lease charge item ${itemIndex}.`,
          );
          return false;
        }
        let amount = tryParseFloat(charge.amount.toString(), -1);
        if (amount < 0) {
          let message =
            "Amount '" + charge.amount + "' is invalid. Cannot be below 0";
          if (
            !isNullUndefined(charge.chargeCode) &&
            !isEmptyString(charge.chargeCode.name)
          ) {
            message =
              "Amount for charge on " +
              charge.chargeCode.name +
              " cannot be below 0";
          }
          issueWarnMessage(message);
          return false;
        }

        // Validate Effective Date
        if (
          isNullUndefined(charge.effectiveDate) ||
          !isValidDate(new Date(charge.effectiveDate))
        ) {
          issueWarnMessage(
            `Start Date is required and must be valid for lease charge item ${itemIndex}.`,
          );
          return false;
        }

        if (sendData.hasRevenueSharing) {
          const revenueSharePercentage = tryParseFloat(
            charge.revenueSharePercentage,
            -1,
          );
          if (charge.chargeCode.code === "REN" && revenueSharePercentage <= 0) {
            let message =
              "revenue Share Percentage on " +
              charge.chargeCode.name +
              " cannot be 0 or below 0";
            issueWarnMessage(message);
            return false;
          }
        }
      }
    }
    if (sendData.tenant.id === null && sendData.tenant.name === null) {
      issueWarnMessage("Lease must have at least one tenant.");
      return false;
    }
    if (
      isNullUndefined(sendData.leaseTypeCd) ||
      isEmptyString(sendData.leaseTypeCd)
    ) {
      issueWarnMessage("Please provide a Lease Type.");
      return false;
    }

    if (sendData.leaseTypeCd === "COM" && sendData.hasRevenueSharing === true) {
      const item = sendData.leaseChargeItems.filter(
        (each) => each && each.revenueSharePercentage,
      );
      if (isEmptyArray(item)) {
        issueWarnMessage(
          "A revenue share percentage should be defined for a rent charge.",
        );
        return false;
      }
    }

    if (
      isNullUndefined(sendData.unitIds) ||
      !isArray(sendData.unitIds) ||
      sendData.unitIds.length === 0
    ) {
      issueWarnMessage("Please select at least one Unit.");
      return false;
    }

    setSelectedLease(sendData);
    if (!validateLatePenalty(latePenalty)) {
      return false;
    }
    return true;
  }

  function handleUnitChange(value) {
    let obj = selectedLease;
    obj.unitIds = value.map((op) => op.value);

    setSelectedUnitIds(value);
    setSelectedLease(obj);
    let currentItems = [...chargeItems];
    setChargeUnitsOptions([
      ...new Map(value.map((v) => [v.value, v])).values(),
    ]);
    let charges = [];
    for (let opt of value) {
      for (let itm of currentItems) {
        if (opt.value === itm.unit.id) {
          charges.push(itm);
        }
      }
    }
    currentItems = charges;
    leaseUnitCharges(obj.unitIds).then((response) => {
      for (let item of response) {
        let addItem = true;
        for (let charge of currentItems) {
          if (charge.unit.id === item.id) {
            addItem = false;
          }
        }
        if (addItem) {
          // Calculate rent for square meters-based units
          let rentAmount = item.rent;
          if (
            (isNullUndefined(item.rent) ||
              item.rent === 0 ||
              item.rent === "") &&
            item.squareFeet &&
            item.rentPerSquareFoot &&
            item.squareFeet > 0 &&
            item.rentPerSquareFoot > 0
          ) {
            rentAmount = item.squareFeet * item.rentPerSquareFoot;
          }
          currentItems.push({
            unit: { id: item.id, name: "" },
            amount: rentAmount,
            chargeCode: { code: item.code, name: "" },
            taxable: false,
            effectiveDate:
              isEmptyString(selectedLease && selectedLease.effectiveDate) ||
              isNullUndefined(selectedLease && selectedLease.effectiveDate)
                ? new Date()
                : selectedLease && selectedLease.effectiveDate,
            note: "",
          });
        }
      }
      setChargeItems(currentItems);
    });
  }

  function handlePersonOrgSelect(result) {
    let obj = selectedLease;
    obj.tenant = result;
    setSelectedLease(obj);
    setTenantModal(false);
    setIdTypeSearch("");
    setIdNoSearch("");
    setCompanySearch("");
  }

  function handleLeaseChargeItemAdd() {
    let charge = {
      unit: {
        id: "",
        name: "",
      },
      amount: "",
      chargeCode: { code: "", name: "" },
      taxable: false,
      effectiveDate: new Date(),
      note: "",
    };
    setChargeItems((chargeItems) => [...chargeItems, charge]);
  }

  const handlePersonOrgClose = () => {
    setTenantModal(false);
  };

  function showAddNewUserForm(idNoSearch, idTypeSearch) {
    setIdTypeSearch(idTypeSearch);
    setIdNoSearch(idNoSearch);
    setTenantModal(false);
    setAddUserModal(true);
  }

  function showAddNewOrgForm(companySearch) {
    setCompanySearch(companySearch);
    setAddOrganizationModal(true);
  }

  function handleAddOrgClose() {
    setAddOrganizationModal(false);
  }

  function handleAddUserClose() {
    setAddUserModal(false);
  }

  useEffect(() => {
    getNotificationDays().then((notificationDays) =>
      setNotificationDays(notificationDays),
    );
    getRentDays().then((rentDays) => setRentDays(rentDays));
    getRentPeriods().then((billingPeriods) =>
      setBillingPeriods(billingPeriods),
    );
    getFacilityOptions().then((facilityOptions) =>
      setFacilityOptions(facilityOptions),
    );
    getLeaseTerms().then((leaseTermOptions) =>
      setLeaseTermOptions(leaseTermOptions),
    );
    getLeaseTypes().then((leaseTypeOptions) =>
      setLeaseTypeOptions(leaseTypeOptions),
    );
  }, []);

  return (
    <ModalContainerModule
      size="md"
      accept={
        props?.task === "Create" || props?.task === "Edit"
          ? saveLease
          : props?.task === "ActiveLeaseEdit"
            ? updateLease
            : () => {}
      }
      cancel={props.handleAddLeaseClose}
      openModal={
        props?.task === "Create" ||
        props?.task === "Edit" ||
        props?.task === "ActiveLeaseEdit"
      }
      modalTitle={`Lease ${selectedLease && selectedLease.billingCode}`}
      acceptButtonText={
        props?.task === "Create"
          ? "Create"
          : props?.task === "Edit"
            ? "Edit"
            : props?.task === "ActiveLeaseEdit"
              ? "Edit Active Lease"
              : ""
      }
    >
      <ResponsiveRow sx={{ paddingTop: 0 }}>
        <Paper
          variant=""
          sx={{
            width: "100%",
            height: "auto",
            margin: "auto",
            padding: "10px",
            textAlign: "left",
          }}
        >
          <Typography
            sx={{ marginBottom: "5px" }}
            id="modal-modal-title"
            variant="h5"
            component="h4"
          >
            Lease Details
          </Typography>
          <ResponsiveRow
            container
            sx={{
              justifyContent: { xs: "center", lg: "space-between" },
            }}
          >
            <FormControl
              item
              required={true}
              sx={{
                width: { xs: "100%", lg: "33.3%" },
                marginBottom: "10px",
              }}
            >
              {/* required */}
              <InputLabel>Lease Terms</InputLabel>
              <Select
                label="Lease Terms"
                sx={{ width: { xs: "100%", lg: "90%" } }}
                id={"leaseTerms"}
                value={leaseTerm}
                onChange={leaseTermChanged}
              >
                {leaseTermOptions && leaseTermOptions.length > 0 ? (
                  leaseTermOptions.map(function (leaseTermItem, i) {
                    return (
                      <MenuItem key={i} value={leaseTermItem.value}>
                        {leaseTermItem.label}
                      </MenuItem>
                    );
                  }, this)
                ) : (
                  <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
                )}
              </Select>
            </FormControl>
            <FormControl
              item
              required={true}
              sx={{
                width: { xs: "100%", lg: "33.3%" },
                marginBottom: "10px",
              }}
            >
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="en-gb"
              >
                <DatePicker
                  label="Start Date"
                  sx={{ width: { xs: "100%", lg: "90%" } }}
                  id={"startDate"}
                  value={dayjs(startDate)}
                  slotProps={{ textField: { required: true }}}
                  disabled={props?.task === "ActiveLeaseEdit"}
                  onChange={handleStartDateChange}
                />
              </LocalizationProvider>
            </FormControl>

            {selectedLease && selectedLease.leaseTerms === "FXD" && (
              <FormControl
                item
                required={true}
                sx={{
                  width: { xs: "100%", lg: "33.3%" },
                  marginBottom: "10px",
                }}
              >
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale="en-gb"
                >
                  <DatePicker
                    label="End Date"
                    sx={{ width: { xs: "100%", lg: "90%" } }}
                    id={"expirationDate"}
                    value={dayjs(expirationDate)}
                    slotProps={{ textField: { required: true }}}
                    disabled={false}
                    onChange={handleExpirationDateChange}
                    disablePast
                  />
                </LocalizationProvider>
              </FormControl>
            )}

            <FormControl
              item
              required={true}
              sx={{
                width: { xs: "100%", lg: "33.3%" },
                marginBottom: "10px",
              }}
            >
              {/* required */}
              <InputLabel>Lease Type</InputLabel>
              <Select
                label="Lease Type"
                sx={{ width: { xs: "100%", lg: "90%" } }}
                id={"leaseType"}
                value={leaseTypeCd}
                disabled={props?.task === "ActiveLeaseEdit"}
                onChange={leaseTypeChanged}
              >
                {leaseTypeOptions && leaseTypeOptions.length > 0 ? (
                  leaseTypeOptions.map(function (leaseType, i) {
                    return (
                      <MenuItem key={i} value={leaseType.value}>
                        {leaseType.label}
                      </MenuItem>
                    );
                  }, this)
                ) : (
                  <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
                )}
              </Select>
            </FormControl>

            <ResponsiveRow
              sx={{
                width: { xs: "100%", lg: "33.3%" },
                marginBottom: "10px",
                flexWrap: "nowrap",
                justifyContent: "flex-start",
                alignItems: "center",
                padding: 0,
              }}
            >
              <FormControl
                item
                required={true}
                sx={{
                  width: "80%",
                }}
              >
                {selectedLease &&
                  selectedLease.tenant &&
                  selectedLease.tenant.name === null && (
                    <InputLabel>Tenant</InputLabel>
                  )
                }
                <OutlinedInput
                  label="Tenant"
                  sx={{ width: { xs: "100%", lg: "100%" } }}
                  id={"tenant"}
                  value={
                    selectedLease &&
                    selectedLease.tenant &&
                    selectedLease.tenant.name
                  }
                  disabled
                  inputProps={
                    <TextField sx={{ width: { xs: "100%", lg: "90%" } }} />
                  }
                />
              </FormControl>
              {props?.task !== "ActiveLeaseEdit" && (
                <IconButton
                  color="primary"
                  aria-label="add Tenant"
                  title={"Add Tenant"}
                  sx={{
                    margin: "auto 10px",
                    height: "50px",
                    width: "50px",
                    backgroundColor: "#037171",
                  }}
                  onClick={() => {
                    setTenantModal(true);
                  }}
                >
                  {(() => {
                    const hasContact =
                        (!isNullUndefined(selectedLease?.tenant?.name) &&
                            !isEmptyString(selectedLease?.tenant?.name));

                    return !hasContact ? (
                        <Tooltip title="Add tenant">
                          <Add sx={{ color: "white" }} />
                        </Tooltip>
                    ) : (
                        <Tooltip title="Switch tenant">
                          <Cached sx={{ color: "white" }} />
                        </Tooltip>
                    );
                  })()}
                </IconButton>
              )}
            </ResponsiveRow>

            <FormControl
              item
              required={true}
              sx={{
                width: { xs: "100%", lg: "33.3%" },
                marginBottom: "10px",
              }}
            >
              {/* required */}
              <InputLabel id="billingPeriod-label">Rent Frequency</InputLabel>
              <Select
                label="Rent Frequency"
                labelId="billingPeriod-label"
                sx={{ width: { xs: "100%", lg: "90%" } }}
                id={"billingPeriod"}
                value={rentPeriodCode}
                onChange={handleRentPeriodChange}
              >
                {billingPeriods && billingPeriods.length > 0 ? (
                  billingPeriods.map(function (billingPeriod, i) {
                    return (
                      <MenuItem key={i} value={billingPeriod.value}>
                        {billingPeriod.label}
                      </MenuItem>
                    );
                  }, this)
                ) : (
                  <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
                )}
              </Select>
            </FormControl>

            {selectedLease && selectedLease.billingPeriod === "MNTH" && (
              <FormControl
                item
                required={true}
                sx={{
                  width: { xs: "100%", lg: "33.3%" },
                  marginBottom: "10px",
                }}
              >
                {/* required */}
                <InputLabel>
                  {hasRevenueSharing ? "Notification Day" : "Rent Due Day"}
                </InputLabel>
                <Select
                  label={
                    hasRevenueSharing ? "Notification Day" : "Rent Due Day"
                  }
                  sx={{ width: { xs: "100%", lg: "90%" } }}
                  id={"billingDay"}
                  value={hasRevenueSharing ? notificationDay : rentDay}
                  onChange={
                    hasRevenueSharing
                      ? handleNotificationDayChange
                      : handleRentDayChange
                  }
                  defaultValue={[""]}
                >
                  {hasRevenueSharing &&
                  notificationDays &&
                  notificationDays.length > 0 ? (
                    notificationDays.map(function (weekDay, i) {
                      return (
                        <MenuItem key={i} value={weekDay.value}>
                          {weekDay.label}
                        </MenuItem>
                      );
                    }, this)
                  ) : rentDays && rentDays.length > 0 ? (
                    rentDays.map(function (weekDay, i) {
                      return (
                        <MenuItem key={i} value={weekDay.value}>
                          {weekDay.label}
                        </MenuItem>
                      );
                    }, this)
                  ) : (
                    <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
                  )}
                </Select>
              </FormControl>
            )}
            {selectedLease &&
              (rentPeriodCode === "ANU" || rentPeriodCode === "QT") && (
                <FormControl
                  item
                  sx={{
                    width: { xs: "100%", lg: "33.3%" },
                    marginBottom: "10px",
                  }}
                >
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="en-gb"
                  >
                    <DatePicker
                      label={
                        hasRevenueSharing
                          ? "Notification Date"
                          : "Next Rent Due Date"
                      }
                      sx={{ width: { xs: "100%", lg: "90%" } }}
                      id={"nextRentDate"}
                      value={dayjs(
                        hasRevenueSharing ? notificationDate : rentDate,
                      )}
                      onChange={
                        hasRevenueSharing
                          ? handleNotificationDateChange
                          : handleNextRentDateChange
                      }
                    />
                  </LocalizationProvider>
                </FormControl>
              )}

            <FormControl
              item
              required={true}
              sx={{
                width: { xs: "100%", lg: "33.3%" },
                marginBottom: "10px",
              }}
            >
              {/* required */}
              <InputLabel>Facility</InputLabel>
              <Select
                label="Facility"
                sx={{ width: { xs: "100%", lg: "90%" } }}
                id={"facility"}
                value={selectedLease && selectedLease.facilityId}
                disabled
                onChange={(event) => console.log()}
              >
                {facilityOptions && facilityOptions.length > 0 ? (
                  facilityOptions.map(function (facility, i) {
                    return (
                      <MenuItem key={i} value={facility.value}>
                        {facility.label}
                      </MenuItem>
                    );
                  }, this)
                ) : (
                  <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
                )}
              </Select>
            </FormControl>
            {props?.task !== "ActiveLeaseEdit" && (
              <FormControl
                item
                sx={{
                  width: { xs: "100%", lg: "33.3%" },
                  marginBottom: "10px",
                }}
              >
                <MUIAutoCompleteMultiSelectForm
                  options={unitOptions}
                  title="Unit(s)"
                  label="Unit(s)"
                  placeholder="Select Unit(s)"
                  selectedOptions={selectedUnitIds}
                  isRequired={true}
                  disabled={props?.task === "ActiveLeaseEdit"}
                  onSelect={(event, newValue) => handleUnitChange(newValue)}
                  sx={{ width: { xs: "100%", lg: "90%" } }}
                  limitTags={4}
                />
              </FormControl>
            )}
            {props?.task === "ActiveLeaseEdit" && (
              <FormControl
                item
                sx={{
                  width: { xs: "100%", lg: "33.3%" },
                  marginBottom: "10px",
                }}
              >
                <InputLabel>Unit(s)</InputLabel>
                <OutlinedInput
                  label="Unit(s)"
                  sx={{ width: { xs: "100%", lg: "33.3%" } }}
                  value={selectedLease && selectedLease.unitNames}
                  disabled={true}
                  inputProps={
                    <TextField sx={{ width: { xs: "100%", lg: "90%" } }} />
                  }
                />
              </FormControl>
            )}
            <ResponsiveRow
              sx={{
                width: "100%",
              }}
            >
              <FormControl
                sx={
                  leaseTypeCd === "COM"
                    ? { width: { sm: "100%", md: "50%", xl: "50%" } }
                    : { width: "100%" }
                }
              >
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography>Increment Rent</Typography>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={incrementRent}
                        onChange={handleIncrementRentSwitchToggle}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    }
                  />
                </Stack>
              </FormControl>
              {leaseTypeCd === "COM" && (
                <FormControl
                  sx={{ width: { sm: "100%", md: "50%", xl: "50%" } }}
                >
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography>Include Revenue Sharing</Typography>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={hasRevenueSharing}
                          onChange={handleRevenueShareToggle}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      }
                    />
                  </Stack>
                </FormControl>
              )}
            </ResponsiveRow>
            <ResponsiveRow
              sx={{
                width: "100%",
              }}
            >
              {incrementRent && (
                <FormControl sx={{ width: { xs: "100%", lg: "50%" } }}>
                  <InputLabel>Increment Period (years)</InputLabel>
                  <OutlinedInput
                    label="Increment Period (years)"
                    sx={{ width: { xs: "100%", lg: "90%" } }}
                    id={"incrementPeriod"}
                    value={incrementPeriod}
                    disabled={false}
                    onChange={handleIncrementPeriodChange}
                    inputProps={
                      <TextField sx={{ width: { xs: "100%", lg: "90%" } }} />
                    }
                  />
                </FormControl>
              )}
              {incrementRent && (
                <FormControl
                  item
                  sx={{
                    width: { xs: "100%", lg: "50%" },
                    marginBottom: "10px",
                  }}
                >
                  <FormLabel>Increment Type</FormLabel>

                  <RadioGroup
                    row
                    sx={{ width: "100%" }}
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="use-radio-group"
                  >
                    <FormControlLabel
                      name="radio"
                      control={
                        <Radio
                          checked={incrementType === "Percentage"}
                          value="Percentage"
                          onClick={onRadioChange}
                        />
                      }
                      label="Percentage"
                    />
                    <FormControlLabel
                      name="radio"
                      control={
                        <Radio
                          checked={incrementType === "Amount"}
                          value="Amount"
                          onClick={onRadioChange}
                        />
                      }
                      label="Amount"
                    />
                  </RadioGroup>
                </FormControl>
              )}
              {incrementRent && incrementType === "Percentage" && (
                <Grid item sx={{ width: { xs: "100%", lg: "50%" } }}>
                  <InputLabel>Rent Increment (%)</InputLabel>
                  <TextField
                    sx={{ width: { xs: "100%", lg: "90%" } }}
                    id={"incrementPercentage"}
                    value={rentIncrementPercentage}
                    disabled={false}
                    onChange={handleIncrementChange}
                  />
                </Grid>
              )}
              {incrementRent && incrementType === "Amount" && (
                <Grid item sx={{ width: { xs: "100%", lg: "50%" } }}>
                  <InputLabel>Rent Increment Amount</InputLabel>
                  <TextField
                    sx={{ width: { xs: "100%", lg: "90%" } }}
                    id={"incrementAmount"}
                    value={rentIncrementAmount}
                    disabled={false}
                    onChange={handleIncrementChange}
                  />
                </Grid>
              )}
            </ResponsiveRow>

            {incrementRent && (
              <ResponsiveRow
                sx={{
                  width: "100%",
                }}
              >
                <Alert severity="info">
                  Click on the toggle button below if there is security deposit
                  increment. Tenant will be invoiced the difference in order to
                  top up the security deposit account.
                </Alert>
                <FormControl
                  sx={{ width: { sm: "100%", md: "100%", xl: "100%" } }}
                >
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography>Increment Deposit</Typography>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={incrementDeposit}
                          onChange={handleIncrementDepositSwitchToggle}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      }
                    />
                  </Stack>
                </FormControl>
              </ResponsiveRow>
            )}
          </ResponsiveRow>
        </Paper>
        <br />
        <LatePenaltyConfig value={latePenalty} onChange={setLatePenalty} />
        <br />
        <Paper
          variant=""
          sx={{
            width: "100%",
            height: "auto",
            margin: "auto",
            padding: "10px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            sx={{ marginBottom: "5px" }}
            id="modal-modal-title"
            variant="h5"
            component="h4"
          >
            Lease Charges
          </Typography>

          {/* Deposit Info Alert */}
          {getDepositInfoMessage() && (
            <Alert severity="info" sx={{ marginBottom: "15px", width: "100%" }}>
              <AlertTitle>Deposit Notice</AlertTitle>
              {getDepositInfoMessage()}
            </Alert>
          )}

          <LeaseChargeItems
            chargeItems={chargeItems}
            setChargeItems={setChargeItems}
            chargeUnitsOptions={chargeUnitsOptions}
            task={props.task}
            hasRevenueSharing={hasRevenueSharing}
          />

          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <ModalAcceptButton
              //   type="submit"
              onClick={handleLeaseChargeItemAdd}
              sx={{ width: { xs: "100%", lg: "200px" } }}
            >
              Add Row
            </ModalAcceptButton>
          </Grid>
        </Paper>
      </ResponsiveRow>
      {/*PERSON/ORG SEARCH MODAL*/}
      {tenantModal && (
        <PersonOrgSearch
          contractType={"lease"}
          showPersonOrgModal={tenantModal}
          handlePersonOrgClose={handlePersonOrgClose}
          handlePersonOrgSelect={handlePersonOrgSelect}
          showAddNewUserForm={showAddNewUserForm}
          showAddNewOrgForm={showAddNewOrgForm}
        />
      )}

      {/*ADD NEW USER MODAL*/}
      {addUserModal && (
        <AddNewUser
          openModal={addUserModal}
          closeModal={handleAddUserClose}
          searchedIdType={idTypeSearch}
          searchedIdNo={idNoSearch}
          saveUser={handlePersonOrgSelect}
          manageUsers={false}
        />
      )}

      {/*ADD NEW ORGANISATION MODAL*/}
      {addOrganizationModal && (
        <AddNewOrganization
          openModal={addOrganizationModal}
          saveOrg={handlePersonOrgSelect}
          searchedName={companySearch}
          handleSave={true}
          closeModal={handleAddOrgClose}
        />
      )}
    </ModalContainerModule>
  );
}
